import React from "react";
import getContainerSizeClass from "@root/helpers/get-container-size-class";
import ReviewCard from "@root/_components/review-card";

const ReviewCards = ({ data }) => {
    const classes = getContainerSizeClass(data?.moduleSettings);
    const reviews = data?.reviews || [];

    if (!reviews || reviews.length === 0) {
        return null;
    }

    return (
        <div className={`review-cards-block ${classes.join(" ")}`}>
            <div className="review-cards-block__grid">
                {reviews.map((review, index) => (
                    <ReviewCard
                        key={review._key || index}
                        authorName={review.authorName}
                        authorLocation={review.authorLocation}
                        reviewMessage={review.reviewMessage}
                        image={review.image}
                        authorImage={review.authorImage}
                    />
                ))}
            </div>
        </div>
    );
};

export default ReviewCards;
